import { useDrag } from "react-use-gesture";
import { DragIndicatorIcon } from "../icons";
import { Box } from "@mui/material";

interface ModalProps {
  open: boolean;
  children: React.ReactNode;
  position: { x: number; y: number };
  setModalPos: (pos: { x: number; y: number }) => void;
  containerRef: React.RefObject<HTMLDivElement>;
  width: number;
  height: number;
}

export function LabelModeless({
  open,
  children,
  position,
  setModalPos,
  containerRef,
  width,
  height,
}: ModalProps) {
  const bind = useDrag(({ offset }) => {
    if (containerRef.current) {
      const containerRect = containerRef.current.getBoundingClientRect();
      // const newX = Math.min(
      //   Math.max(0, offset[0]),
      //   containerRect.width - width
      // );
      // const newY = Math.min(
      //   Math.max(0, offset[1]),
      //   containerRect.height - height
      // );
      const newX = Math.max(0, offset[0]);
      const newY = Math.max(0, offset[1]);
      setModalPos({ x: newX, y: newY });
    }
  });

  return (
    <Box
      sx={{
        position: "absolute",
        top: `${position.y}px`,
        left: `${position.x}px`,
        backgroundColor: "var*--label-modal-container)",
        color: "var(--label-modal-text)",
        // p: "5px",
        borderRadius: "8px",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        zIndex: 1000,
        display: open ? "flex" : "none",
        width: `${width}px`,
        height: `${height}px`,
      }}
      onClick={(e) => e.stopPropagation()}
      className="steps_2_1"
    >
      <Box
        {...bind()}
        sx={{
          cursor: "move",
          borderRadius: "4px",
          marginBottom: "10px",
          width: "fit-content",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          p: 2,
        }}
      >
        <DragIndicatorIcon />
      </Box>
      {children}
    </Box>
  );
}
